import { useCallback, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectors as authSelectors, actions as authActions } from 'state/auth';

const useAddPermission = () => {
  const user = useSelector(authSelectors.getUser);
  const permissions = useMemo(() => user.user_permissions, [user]);
  const dispatch = useDispatch();

  const removePermission = useCallback(
    (permissionToRemove) => {
      const userWithNewPermissions = {
        ...user,
        user_permissions: permissions.filter((p) => p !== permissionToRemove),
      };
      dispatch(authActions.setUser(userWithNewPermissions));
    },
    [dispatch, permissions, user]
  );

  return removePermission;
};

export default useAddPermission;
